import { useMutation } from '@apollo/client'
import { So_RemoteAddToShoppingListDocument } from '@shared/gql/sostoslista-document-nodes'

import { useWriteListDataFragment } from '../support/use-list-data-fragment'
import { shoppingListsQueryContext } from './shopping-lists-query-context'

export interface ProductInput {
  ean: string
  name: string
  quantity: number
  quantityUnit: string
  isReplaceable?: boolean
  commentForPicker?: string
}

export const useAddToListQuery = () => {
  const setListData = useWriteListDataFragment()

  const [createListItem] = useMutation(So_RemoteAddToShoppingListDocument, {
    ...shoppingListsQueryContext,
  })

  return (listId: string, storeId: string, product: ProductInput) =>
    createListItem({
      variables: {
        storeId,
        shoppingListId: listId,
        item: {
          // do not spread product
          // will produce error in api validation, if unexpected fields are sent
          ean: product.ean,
          sokId: product.ean,
          name: product.name,
          quantity: product.quantity,
          quantityUnit: product.quantityUnit,
          isReplaceable: !!product.isReplaceable,
          commentForPicker: product.commentForPicker,
        },
      },
      update: (_, result) => {
        if (!result?.data?.createProductResolvedShoppingListItem.id) {
          throw new Error(`List ${listId} not found in cache`)
        }

        setListData(storeId, result.data?.createProductResolvedShoppingListItem.id, {
          ...result.data.createProductResolvedShoppingListItem,
        })
      },
    }).then((x) => {
      if (!x.data) {
        throw new Error('No data received')
      }

      return x.data.createProductResolvedShoppingListItem
    })
}
